import axios from './axios';

export const getAgentPermissions = async (agentid) => {
  const response = await axios.get(`/agent/permissions`,{agentid});
  return response.data;
};
